<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center">
        <v-col cols="12" sm="4">
          <v-select
            v-model="statisticsSelectModel"
            :items="statisticsItems"
            item-value="value"
            item-text="text"
            label="Период"
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12" sm="4">
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="params.date"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                :label="statisticsSelectModel === 'month' ? 'Месяц' : 'Дата'"
                readonly
                clearable
                dense
                hide-details
              />
            </template>
            <v-date-picker
              v-model="params.date"
              :type="statisticsSelectModel === 'month' ? 'month' : 'date'"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="4">
          <v-select
            v-model="params.cId"
            :items="controllers"
            item-text="name"
            item-value="id"
            label="Контроллер"
            clearable
            dense
            hide-details
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-row>
        <v-col>
          <div id="chart" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  getControllersStatistics,
  getControllersStatisticsMonth,
  getControllers
} from "@/services/device.service";
import ApexCharts from "apexcharts";

export default {
  name: "ControllerStatistics",
  data() {
    return {
      chart: null,
      statisticsSelectModel: "hour",
      controllers: [],

      params: {
        date: new Date().toISOString().substring(0, 10),
        cId: null
      },

      statisticsItems: [
        { value: "month", text: "По дням" },
        { value: "hour", text: "По часам" }
      ],

      chartOptions: {
        chart: {
          width: "100%",
          height: 450,
          type: "bar",
          stacked: true
        },
        plotOptions: {
          bar: {
            vertical: true
          }
        },
        dataLabels: {
          enabled: false
        },
        series: [],
        title: {
          text: ""
        },
        xaxis: {
          categories: []
        },
        legend: {
          position: "right",
          verticalAlign: "top",
          containerMargin: {
            left: 35,
            right: 60
          }
        },
        noData: {
          text: "Нет данных"
        }
      }
    };
  },

  async created() {
    await this.loadControllers();
    this.loadChart();
  },

  mounted() {
    this.chart = new ApexCharts(
      document.querySelector("#chart"),
      this.chartOptions
    );
    this.chart.render();
  },

  beforeDestroy() {
    this.chart && this.chart.destroy();
  },

  watch: {
    statisticsSelectModel() {
      this.loadChart();
    },

    "params.date"() {
      this.loadChart();
    },

    "params.cId"() {
      this.loadChart();
    }
  },

  methods: {
    async loadControllers() {
      try {
        const controllers = await getControllers();
        this.controllers = controllers.filter(c => c.type !== 2 && c.name);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    loadChart() {
      this.statisticsSelectModel === "hour"
        ? this.getControllersHourStatistics()
        : this.getControllersMonthStatistics();
    },

    async getControllersHourStatistics() {
      try {
        await getControllersStatistics(this.params).then(response => {
          if (
            this.statisticsSelectModel === "hour" ||
            this.statisticsSelectModel === null
          ) {
            this.updateSeriesIdentifierTypes(response);
            this.updateOptionsHourChart(response);
          }
        });
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message.message : e,
          type: "error"
        });
      }
    },

    async getControllersMonthStatistics() {
      try {
        await getControllersStatisticsMonth({
          date: this.params.date + "-01",
          cId: this.params.cId
        }).then(response => {
          this.updateSeriesIdentifierTypes(response);
          this.updateOptionsMonthChart(response);
        });
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    updateSeriesIdentifierTypes(response) {
      this.chart.updateSeries([
        {
          name: "QR",
          data: response.map(item => item.qr)
        },
        {
          name: "Карта",
          data: response.map(item => item.card)
        },
        {
          name: "Пульт",
          data: response.map(item => item.console)
        },
        {
          name: "Отклонен",
          data: response.map(item => item.reject)
        }
      ]);
    },

    updateOptionsHourChart(response) {
      this.chart.updateOptions({
        xaxis: {
          categories: response.map(items => {
            return new Date(new Date().setHours(items.index))
              .toLocaleTimeString("ru-RU")
              .substring(0, 2);
          })
        }
      });
    },

    updateOptionsMonthChart(response) {
      this.chart.updateOptions({
        xaxis: {
          categories: response.map(items => {
            return items.index;
          })
        }
      });
    }
  }
};
</script>
